import React from 'react';
import { Quote } from 'lucide-react';
import { EField, FieldRow } from './EditableField';

export default function SectionTestimonials({ section_label = '', title = '', items = [], mode = 'view', onChange }) {
  const upd = (i, k, v) => onChange?.({ items: items.map((it, idx) => idx === i ? { ...it, [k]: v } : it) });
  const add = () => onChange?.({ items: [...items, { quote: 'Beautiful quote', author: 'Name', role: 'Role' }] });
  const rem = (i) => onChange?.({ items: items.filter((_, idx) => idx !== i) });
  return (
    <section className="py-24 bg-ee-bg">
      <div className="ee-container">
        <div className="text-center mb-16">
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={(v) => onChange?.({ section_label: v })} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={(v) => onChange?.({ title: v })} mode={mode} /></FieldRow>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white">{title}</h2>
            </>
          )}
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <div key={i} className="ee-card p-8 relative">
              <Quote className="absolute top-5 left-5 text-gold/30" size={28} />
              <p className="pt-8 text-ee-text2 italic leading-relaxed font-serif text-lg"><EField multiline value={it.quote} onChange={(v) => upd(i, 'quote', v)} mode={mode} /></p>
              <div className="mt-6 pt-4 border-t border-ee-border">
                <div className="text-white text-sm font-medium"><EField value={it.author} onChange={(v) => upd(i, 'author', v)} mode={mode} /></div>
                <div className="text-xs text-gold/80"><EField value={it.role} onChange={(v) => upd(i, 'role', v)} mode={mode} /></div>
              </div>
              {mode === 'edit' && <button onClick={() => rem(i)} className="absolute bottom-2 right-2 text-xs text-red-400">remove</button>}
            </div>
          ))}
        </div>
        {mode === 'edit' && <div className="text-center mt-6"><button onClick={add} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold">+ Testimonial</button></div>}
      </div>
    </section>
  );
}
